import {PartnerStatus, RoleId} from 'common/types';

export interface SummaryStat {
  offersAdded: number;
  priceChanged: number;
  dealsClosed: number;
  interval: 1 | 7 | 30;
}

export interface MarketActivityItem {
  address: string;
  agencyId: null|number;
  avatar: string;
  birthday: string;
  cityId: number;
  date: string;
  domain: string;
  groupId: RoleId;
  itemType: number;
  meta: {
    agencyName?: string;
    expoDate: number;
    partnerStat?: string;
    price: string;
    priceOld: string;
    priceDealClose: string;
    priceDelta: number;
    priceDeltaFormatted: string;
  };
  operType: number;
  partnerStatus: PartnerStatus;
  phone: string;
  rentaId: number;
  rentaImage: string;
  sameAgency: boolean;
  subType: MarketSubTypeEnum;
  userId: number;
  username: string;
  uuid: string;
  speciality: string;
  experience: string;
  isPro: boolean;
  isVerified: boolean;
}

// Same const on backend: SubTypeEnum
export enum MarketSubTypeEnum {
  NewRieltor = 1,
  NewObject = 2,
  PriceChanged = 3,
  DealClosed = 4,
  PartnerRequest = 5,
  Birthday = 7,
}

// Same const on backend
export enum MarketActivityEnum {
  All = 0,
  NewObjects = 1,
  PriceChanged = 2,
  Deals = 3,
  Rieltors = 4,
}

// Same const on backend
export enum MarketRoleEnum {
  All = 0,
  Partner = 1,
  Owner= 2,
  Rieltor = 3,
  Colleague = 4,
}

export interface MarketFilter {
  days: number;
  activity: MarketActivityEnum;
  itemType: string;
  role: MarketRoleEnum;
}

export interface MarketPagination {
  perPage: number;
  currentPage: number;
}

export interface MarketCityInfo {
  nameNom: string;
  nameGen: string;
  namePrep: string;
}
